import ItemSubstitute from './searchGroups/ItemSubstitute.json';
import DeployCustomer from './searchGroups/DeployCustomer.json';
import DeployItemGood from './searchGroups/DeployItemGood.json';
import DeployItemFood from './searchGroups/DeployItemFood.json';
import DeployItemBeverage from './searchGroups/DeployItemBeverage.json';
import DeployItemMaterial from './searchGroups/DeployItemMaterial.json';
import DeployItemConsumable from './searchGroups/DeployItemConsumable.json';
import DeployItemFixedService from './searchGroups/DeployItemFixedService.json';
import DeployItemExtraFee from './searchGroups/DeployItemExtraFee.json';
import DeployItemServicePack from './searchGroups/DeployItemServicePack.json';
import DeployItemDepositPack from './searchGroups/DeployItemDepositPack.json';
// Phase 3b
import DeployStore from './searchGroups/DeployStore.json';
import DeployEXPCostDeferral from './searchGroups/DeployEXPCostDeferral.json';
import DeployAssetBalance from './searchGroups/DeployAssetBalance.json';
import DeployInventoryBalance from './searchGroups/DeployInventoryBalance.json';
import DeployCashBalance from './searchGroups/DeployCashBalance.json';
import DeployEmployeeBalance from './searchGroups/DeployEmployeeBalance.json';
import DeployVendorBalance from './searchGroups/DeployVendorBalance.json';
import DeployTrialBalance from './searchGroups/DeployTrialBalance.json';
import DeployCOA from './searchGroups/DeployCOA.json';
// Sale Channel — INT* (Phase 8B-P3 rename align with BE INTSale*)
import INTSaleApp from './searchGroups/INTSaleApp.json';
import INTConnectionItem from './searchGroups/INTConnectionItem.json';
import INTSaleOrder from './searchGroups/INTSaleOrder.json';
import INTSaleEvent from './searchGroups/INTSaleEvent.json';
import INTSaleJobQueue from './searchGroups/INTSaleJobQueue.json';
import INTSaleFulfillment from './searchGroups/INTSaleFulfillment.json';
// Social Channel — INTSocial* (Phase 8E P1: filter tabs for all 9 services)
import INTSocialApp from './searchGroups/INTSocialApp.json';
import INTSocialShop from './searchGroups/INTSocialShop.json';
import INTSocialChat from './searchGroups/INTSocialChat.json';
import INTSocialMessage from './searchGroups/INTSocialMessage.json';
import INTSocialComment from './searchGroups/INTSocialComment.json';
import INTSocialOrder from './searchGroups/INTSocialOrder.json';
import INTSocialEvent from './searchGroups/INTSocialEvent.json';
import INTSocialJobQueue from './searchGroups/INTSocialJobQueue.json';

// Integration umbrella (Phase 9B-C) — INTConnection + 5 INT*App
import INTConnection from './searchGroups/INTConnection.json';
import INTAdvertiseApp from './searchGroups/INTAdvertiseApp.json';
import INTAffiliateApp from './searchGroups/INTAffiliateApp.json';
import INTReviewApp from './searchGroups/INTReviewApp.json';
import INTMessageEmailApp from './searchGroups/INTMessageEmailApp.json';
import INTMessageSmsApp from './searchGroups/INTMessageSmsApp.json';
import MEDDocument from './searchGroups/MEDDocument.json';
import AIImportBatch from './searchGroups/AIImportBatch.json';
import APInvoicable from './searchGroups/APInvoicable.json';
import APInvoice from './searchGroups/APInvoice.json';
import APInvoiceItem from './searchGroups/APInvoiceItem.json';
import APImportCost from './searchGroups/APImportCost.json';
import APImportCostItem from './searchGroups/APImportCostItem.json';
import APRequest from './searchGroups/APRequest.json';
import APOrder from './searchGroups/APOrder.json';
import APOrderItem from './searchGroups/APOrderItem.json';
import APQuotation from './searchGroups/APQuotation.json';
import APVendorPromotion from './searchGroups/APVendorPromotion.json';
import APPayment from './searchGroups/APPayment.json';
import APReceive from './searchGroups/APReceive.json';
import APReceiveItem from './searchGroups/APReceiveItem.json';
import APReturn from './searchGroups/APReturn.json';
import APReturnItem from './searchGroups/APReturnItem.json';
import ARAppointment from './searchGroups/ARAppointment.json';
import ARProductCampaign from './searchGroups/ARProductCampaign.json';
import AREvent from './searchGroups/AREvent.json';
import AREventSession from './searchGroups/AREventSession.json';
import AREventSessionStatus from './searchGroups/AREventSessionStatus.json';
import AREventTicket from './searchGroups/AREventTicket.json';
import ARInvoicable from './searchGroups/ARInvoicable.json';
import ARInvoice from './searchGroups/ARInvoice.json';
import ARInvoiceItem from './searchGroups/ARInvoiceItem.json';
import ARIssue from './searchGroups/ARIssue.json';
import ARIssueItem from './searchGroups/ARIssueItem.json';
import ARItemStatus from './searchGroups/ARItemStatus.json';
import AROrder from './searchGroups/AROrder.json';
import AROrderItem from './searchGroups/AROrderItem.json';
import ARPayment from './searchGroups/ARPayment.json';
import ARPriceList from './searchGroups/ARPriceList.json';
import ARPriceListItem from './searchGroups/ARPriceListItem.json';
import ARPromotion from './searchGroups/ARPromotion.json';
import ARPromotionItem from './searchGroups/ARPromotionItem.json';
import ARReturn from './searchGroups/ARReturn.json';
import ARReturnItem from './searchGroups/ARReturnItem.json';
import ARServeStatus from './searchGroups/ARServeStatus.json';
import ARServeCooking from './searchGroups/ARServeCooking.json';
import ARServeService from './searchGroups/ARServeService.json';
import ARServeMaterialIssue from './searchGroups/ARServeMaterialIssue.json';
import ARServeMaterialIssueItem from './searchGroups/ARServeMaterialIssueItem.json';
import ARServeMaterialCounting from './searchGroups/ARServeMaterialCounting.json';
import ARServeMaterialCountingItem from './searchGroups/ARServeMaterialCountingItem.json';
import ARServeMonthlyReport from './searchGroups/ARServeMonthlyReport.json';
import ARTravel from './searchGroups/ARTravel.json';
import ARTravelSession from './searchGroups/ARTravelSession.json';
import ARRentalBooking from './searchGroups/ARRentalBooking.json';
import ARRentalBookingItem from './searchGroups/ARRentalBookingItem.json';

import ARRentalField from './searchGroups/ARRentalField.json';
import ARRentalMachine from './searchGroups/ARRentalMachine.json';
import ARRentalRoom from './searchGroups/ARRentalRoom.json';
import ARRentalVehicle from './searchGroups/ARRentalVehicle.json';

import CAAdjust from './searchGroups/CAAdjust.json';
import CABankStatement from './searchGroups/CABankStatement.json';
import CAIssue from './searchGroups/CAIssue.json';
import CAIssueRequest from './searchGroups/CAIssueRequest.json';
import CAReceive from './searchGroups/CAReceive.json';
import CAReceiveRequest from './searchGroups/CAReceiveRequest.json';
import CARequest from './searchGroups/CARequest.json';
import CATransfer from './searchGroups/CATransfer.json';
import CRMComsRule from './searchGroups/CRMComsRule.json';
import CRMComsInit from './searchGroups/CRMComsInit.json';
import Customer from './searchGroups/Customer.json';
import CRMLead from './searchGroups/CRMLead.json';
import CRMTicket from './searchGroups/CRMTicket.json';

import EXPAllocate from './searchGroups/EXPAllocate.json';
import EXPAllocateAP from './searchGroups/EXPAllocateAP.json';
import EXPAllocateAPInput from './searchGroups/EXPAllocateAPInput.json';
import EXPAllocateInput from './searchGroups/EXPAllocateInput.json';
import EXPAllocatePM from './searchGroups/EXPAllocatePM.json';
import EXPInvoicable from './searchGroups/EXPInvoicable.json';
import EXPInvoice from './searchGroups/EXPInvoice.json';
import EXPInvoiceItem from './searchGroups/EXPInvoiceItem.json';
import EXPItem from './searchGroups/EXPItem.json';
import EXPOrder from './searchGroups/EXPOrder.json';
import EXPOrderItem from './searchGroups/EXPOrderItem.json';
import EXPPayment from './searchGroups/EXPPayment.json';
import EXPGeneralOrder from './searchGroups/EXPGeneralOrder.json';
import EXPGeneralOrderItem from './searchGroups/EXPGeneralOrderItem.json';
import EXPPurchaseOrder from './searchGroups/EXPPurchaseOrder.json';
import EXPPurchaseOrderItem from './searchGroups/EXPPurchaseOrderItem.json';
import EXPImportDutyOrder from './searchGroups/EXPImportDutyOrder.json';
import EXPImportDutyOrderItem from './searchGroups/EXPImportDutyOrderItem.json';
import EXPPayrollOrder from './searchGroups/EXPPayrollOrder.json';
import EXPPayrollOrderItem from './searchGroups/EXPPayrollOrderItem.json';
import EXPInsuranceOrder from './searchGroups/EXPInsuranceOrder.json';
import EXPInsuranceOrderItem from './searchGroups/EXPInsuranceOrderItem.json';
import EXPTaxOrder from './searchGroups/EXPTaxOrder.json';
import EXPTaxOrderItem from './searchGroups/EXPTaxOrderItem.json';
import EXPLogisticOrder from './searchGroups/EXPLogisticOrder.json';
import EXPLogisticOrderItem from './searchGroups/EXPLogisticOrderItem.json';
import EXPEquipmentProcurementOrder from './searchGroups/EXPEquipmentProcurementOrder.json';
import EXPEquipmentProcurementOrderItem from './searchGroups/EXPEquipmentProcurementOrderItem.json';
import EXPAssetProcurementOrder from './searchGroups/EXPAssetProcurementOrder.json';
import EXPAssetProcurementOrderItem from './searchGroups/EXPAssetProcurementOrderItem.json';
import EXPExtraPayableOrder from './searchGroups/EXPExtraPayableOrder.json';
import EXPExtraPayableOrderItem from './searchGroups/EXPExtraPayableOrderItem.json';
import EXPBudget from './searchGroups/EXPBudget.json';
import WFApprovalPolicys from './searchGroups/WFApprovalPolicys.json';
import WFApprovalPendings from './searchGroups/WFApprovalPendings.json';
import OFTask from './searchGroups/OFTask.json';
import OFDailyReport from './searchGroups/OFDailyReport.json';
import OFMeeting from './searchGroups/OFMeeting.json';
import OFDocument from './searchGroups/OFDocument.json';
import OFBulletin from './searchGroups/OFBulletin.json';
import OFObjective from './searchGroups/OFObjective.json';

import EXRInvoicable from './searchGroups/EXRInvoicable.json';
import EXRInvoice from './searchGroups/EXRInvoice.json';
import EXRInvoiceItem from './searchGroups/EXRInvoiceItem.json';
import EXROrder from './searchGroups/EXROrder.json';
import EXROrderItem from './searchGroups/EXROrderItem.json';
import EXROtherOrder from './searchGroups/EXROtherOrder.json';
import EXROtherOrderItem from './searchGroups/EXROtherOrderItem.json';

import FixedService from './searchGroups/FixedService.json';
import ExpandableService from './searchGroups/ExpandableService.json';
import Food from './searchGroups/Food.json';
import Beverage from './searchGroups/Beverage.json';
import Good from './searchGroups/Good.json';
import HRAdjust from './searchGroups/HRAdjust.json';
import HRAdjustItem from './searchGroups/HRAdjustItem.json';
import HRAllowance from './searchGroups/HRAllowance.json';
import HRAllowanceItem from './searchGroups/HRAllowanceItem.json';
import HRCommision from './searchGroups/HRCommision.json';
import HRCommisionItem from './searchGroups/HRCommisionItem.json';
import HROrder from './searchGroups/HROrder.json';
import HROrderItem from './searchGroups/HROrderItem.json';
import HRWorkingSalary from './searchGroups/HRWorkingSalary.json';
import HRWorkingSalaryItem from './searchGroups/HRWorkingSalaryItem.json';
import HRWorkingAttendance from './searchGroups/HRWorkingAttendance.json';
import HRWorkingTimesheet from './searchGroups/HRWorkingTimesheet.json';
import HRWorkingDay from './searchGroups/HRWorkingDay.json';
import HRLeave from './searchGroups/HRLeave.json';
import HROvertimeRequest from './searchGroups/HROvertimeRequest.json';
import HRAttendanceBatch from './searchGroups/HRAttendanceBatch.json';

import ICAdjust from './searchGroups/ICAdjust.json';
import ICAdjustItem from './searchGroups/ICAdjustItem.json';
import ICCounting from './searchGroups/ICCounting.json';
import ICCountingItem from './searchGroups/ICCountingItem.json';
import ICInventorySerial from './searchGroups/ICInventorySerial.json';
import ICInventoryStock from './searchGroups/ICInventoryStock.json';
import ICIssue from './searchGroups/ICIssue.json';
import ICIssueItem from './searchGroups/ICIssueItem.json';
import ICReceipt from './searchGroups/ICReceipt.json';
import ICReceiptItem from './searchGroups/ICReceiptItem.json';
import ICTransfer from './searchGroups/ICTransfer.json';
import ICTransferItem from './searchGroups/ICTransferItem.json';
import ICBOM from './searchGroups/ICBOM.json';
import ICAssemblyOrder from './searchGroups/ICAssemblyOrder.json';
import ICDeassemblyOrder from './searchGroups/ICDeassemblyOrder.json';
import ICAssemblyOrderItem from './searchGroups/ICAssemblyOrderItem.json';
import ICLocation from './searchGroups/ICLocation.json';
import ICLocationAudit from './searchGroups/ICLocationAudit.json';
import ICLotAudit from './searchGroups/ICLotAudit.json';
import ICSerialAudit from './searchGroups/ICSerialAudit.json';

import LGOrderItem from './searchGroups/LGOrderItem.json';
import LGTransport from './searchGroups/LGTransport.json';
import PMFeature from './searchGroups/PMFeature.json';
import PMProject from './searchGroups/PMProject.json';
import PMMilestone from './searchGroups/PMMilestone.json';
import PMProjectTemplate from './searchGroups/PMProjectTemplate.json';
import PMResource from './searchGroups/PMResource.json';
import PMTask from './searchGroups/PMTask.json';
import Service from './searchGroups/Service.json';
import SPCPurchaseByICRule from './searchGroups/SPCPurchaseByICRule.json';
import SPCPurchaseByICRuleItem from './searchGroups/SPCPurchaseByICRuleItem.json';
import SPCPurchaseByARRule from './searchGroups/SPCPurchaseByARRule.json';
import SPCPurchaseByARRuleItem from './searchGroups/SPCPurchaseByARRuleItem.json';
import SPCSourcingPolicy from './searchGroups/SPCSourcingPolicy.json';
import SPCSourcingPolicyItem from './searchGroups/SPCSourcingPolicyItem.json';
import SPCSafeStockStatus from './searchGroups/SPCSafeStockStatus.json';
import SPCDemandPurchase from './searchGroups/SPCDemandPurchase.json';
import SPCDemandTransfer from './searchGroups/SPCDemandTransfer.json';
import SPCDemand from './searchGroups/SPCDemand.json';
import SPCDemandPlanning from './searchGroups/SPCDemandPlanning.json';
import Vendor from './searchGroups/Vendor.json';

import FAAsset from './searchGroups/FAAsset.json';
import FAAssetRegister from './searchGroups/FAAssetRegister.json';
import FAAssetAdjInc from './searchGroups/FAAssetAdjInc.json';
import FAAssetAdjDec from './searchGroups/FAAssetAdjDec.json';
import FAAssetDispose from './searchGroups/FAAssetDispose.json';
import FAAssetDepreciate from './searchGroups/FAAssetDepreciate.json';

import FAEquipment from './searchGroups/FAEquipment.json';
import FAEquipmentRegister from './searchGroups/FAEquipmentRegister.json';
import FAEquipmentDispose from './searchGroups/FAEquipmentDispose.json';
import FAEquipmentDepreciate from './searchGroups/FAEquipmentDepreciate.json';

import MFProceduce from './searchGroups/MFProceduce.json';
import MFRoute from './searchGroups/MFRoute.json';
import MFBOM from './searchGroups/MFBOM.json';
import MFMDSTicket from './searchGroups/MFMDSTicket.json';
import MFMDSTicketItem from './searchGroups/MFMDSTicketItem.json';
import MFMDSSummary from './searchGroups/MFMDSSummary.json';
import MFMDSSummaryItem from './searchGroups/MFMDSSummaryItem.json';
import MFMPS from './searchGroups/MFMPS.json';
import MFMPSItem from './searchGroups/MFMPSItem.json';

import MFMRPSummary from './searchGroups/MFMRPSummary.json';
import MFMRPSummaryItem from './searchGroups/MFMRPSummaryItem.json';

import MFMakeOrder from './searchGroups/MFMakeOrder.json';
import MFMakeOrderItem from './searchGroups/MFMakeOrderItem.json';
import MFWorkTicket from './searchGroups/MFWorkTicket.json';
import MFWorkMove from './searchGroups/MFWorkMove.json';
import MFMaterialIssue from './searchGroups/MFMaterialIssue.json';
import MFMaterialIssueItem from './searchGroups/MFMaterialIssueItem.json';
import ARServeBOM from './searchGroups/ARServeBOM.json';

import PNLJournal from './searchGroups/PNLJournal.json';
import PNLJournalLedgerStatus from './searchGroups/PNLJournalLedgerStatus.json';
import PNLPosting from './searchGroups/PNLPosting.json';
import PNLServeCosting from './searchGroups/PNLServeCosting.json';
import PNLPostingRetry from './searchGroups/PNLPostingRetry.json';
import PNLLedgerPosting from './searchGroups/PNLLedgerPosting.json';
import PNLPostByTemplate from './searchGroups/PNLPostByTemplate.json';
import PNLPostByVoucher from './searchGroups/PNLPostByVoucher.json';
import PNLReEntry from './searchGroups/PNLReEntry.json';
import PNLRejected from './searchGroups/PNLRejected.json';
import PNLJournalGroupingTemplate from './searchGroups/PNLJournalGroupingTemplate.json';
import PNLJournalGrouping from './searchGroups/PNLJournalGrouping.json';

import GLCostCenter from './searchGroups/GLCostCenter.json';
import ExchangeRate from './searchGroups/ExchangeRate.json';
import GLJournal from './searchGroups/GLJournal.json';
import GLJournalEntry from './searchGroups/GLJournalEntry.json';
import GLVoucherPacks from './searchGroups/GLVoucher.js';
import LedgerStatusPacks from './searchGroups/LedgerStatus.js';
import GLPostedJournal from './searchGroups/GLPostedJournal.json';
import GLPostedJournalEntry from './searchGroups/GLPostedJournalEntry.json';
import GLAdjustBalance from './searchGroups/GLAdjustBalance.json';
import GLAdjustBalanceItem from './searchGroups/GLAdjustBalanceItem.json';
import GLServeCosting from './searchGroups/GLServeCosting.json';
import GLServeCostingItem from './searchGroups/GLServeCostingItem.json';
import GLMFCosting from './searchGroups/GLMFCosting.json';
import GLMFCostingItem from './searchGroups/GLMFCostingItem.json';
import GLPNLCalculate from './searchGroups/GLPNLCalculate.json';
import GLPNLCalculateItem from './searchGroups/GLPNLCalculateItem.json';
import GLFXRevaluation from './searchGroups/GLFXRevaluation.json';

import ARServicePlan from './searchGroups/ARServicePlan.json';
import ARServicePlanItem from './searchGroups/ARServicePlanItem.json';
import ARServiceOrder from './searchGroups/ARServiceOrder.json';
import ARTradeIn from './searchGroups/ARTradeIn.json';
import ARWarranty from './searchGroups/ARWarranty.json';
import ARWarrantyClaim from './searchGroups/ARWarrantyClaim.json';
import ARProductTrial from './searchGroups/ARProductTrial.json';
import ARDeliveryInspection from './searchGroups/ARDeliveryInspection.json';
import ARAssetRegistration from './searchGroups/ARAssetRegistration.json';
import ARMaintainPlan from './searchGroups/ARMaintainPlan.json';
import ARMaintainReminder from './searchGroups/ARMaintainReminder.json';
import B2BPartnership from './searchGroups/B2BPartnership.json';
import B2BCatalog from './searchGroups/B2BCatalog.json';
import B2BOrder from './searchGroups/B2BOrder.json';
import B2BItemMapping from './searchGroups/B2BItemMapping.json';
import B2BSupplierPartner from './searchGroups/B2BSupplierPartner.json';
import B2BSupplierOrder from './searchGroups/B2BSupplierOrder.json';
import B2BBuyerPartner from './searchGroups/B2BBuyerPartner.json';
import B2BBuyerOrder from './searchGroups/B2BBuyerOrder.json';
import SysDataAudit from './searchGroups/SysDataAudit.json';
import SysDataBackup from './searchGroups/SysDataBackup.json';
import AIJobQueue from './searchGroups/AIJobQueue.json';
import AIKnowledgeBase from './searchGroups/AIKnowledgeBase.json';
import AIDocumentSource from './searchGroups/AIDocumentSource.json';
import POSCashSettlement from './searchGroups/POSCashSettlement.json';

var data = [];

data.push({ name: 'MEDDocument', value: MEDDocument });
data.push({ name: 'AIImportBatch', value: AIImportBatch });
data.push({ name: 'APInvoicable', value: APInvoicable });
data.push({ name: 'APInvoice', value: APInvoice });
data.push({ name: 'APInvoiceItem', value: APInvoiceItem });
data.push({ name: 'APImportCost', value: APImportCost });
data.push({ name: 'APImportCostItem', value: APImportCostItem });
data.push({ name: 'APRequest', value: APRequest });
data.push({ name: 'APOrder', value: APOrder });
data.push({ name: 'APOrderItem', value: APOrderItem });
data.push({ name: 'APPayment', value: APPayment });
data.push({ name: 'APReceive', value: APReceive });
data.push({ name: 'APReceiveItem', value: APReceiveItem });
data.push({ name: 'APReturn', value: APReturn });
data.push({ name: 'APReturnItem', value: APReturnItem });
data.push({ name: 'ARAppointment', value: ARAppointment });
data.push({ name: 'ARProductCampaign', value: ARProductCampaign });
data.push({ name: 'AREvent', value: AREvent });
data.push({ name: 'AREventSession', value: AREventSession });
data.push({ name: 'AREventSessionStatus', value: AREventSessionStatus });
data.push({ name: 'AREventTicket', value: AREventTicket });
data.push({ name: 'ARInvoicable', value: ARInvoicable });
data.push({ name: 'ARInvoice', value: ARInvoice });
data.push({ name: 'ARInvoiceItem', value: ARInvoiceItem });
data.push({ name: 'ARIssue', value: ARIssue });
data.push({ name: 'ARIssueItem', value: ARIssueItem });
data.push({ name: 'ARItemStatus', value: ARItemStatus });
data.push({ name: 'AROrder', value: AROrder });
data.push({ name: 'AROrderItem', value: AROrderItem });
data.push({ name: 'ARPayment', value: ARPayment });
data.push({ name: 'ARPriceList', value: ARPriceList });
data.push({ name: 'ARPriceListItem', value: ARPriceListItem });
data.push({ name: 'ARPromotion', value: ARPromotion });
data.push({ name: 'ARPromotionItem', value: ARPromotionItem });
data.push({ name: 'ARReturn', value: ARReturn });
data.push({ name: 'ARReturnItem', value: ARReturnItem });
data.push({ name: 'ARServeStatus', value: ARServeStatus });
data.push({ name: 'ARServeCooking', value: ARServeCooking });
data.push({ name: 'ARServeService', value: ARServeService });
data.push({ name: 'ARTravel', value: ARTravel });
data.push({ name: 'ARTravelSession', value: ARTravelSession });
data.push({ name: 'ARRentalBooking', value: ARRentalBooking });
data.push({ name: 'ARRentalBookingItem', value: ARRentalBookingItem });
data.push({ name: 'ARRentalField', value: ARRentalField });
data.push({ name: 'ARRentalMachine', value: ARRentalMachine });
data.push({ name: 'ARRentalRoom', value: ARRentalRoom });
data.push({ name: 'ARRentalVehicle', value: ARRentalVehicle });
data.push({ name: 'CAAdjust', value: CAAdjust });
data.push({ name: 'CABankStatement', value: CABankStatement });
data.push({ name: 'CAIssue', value: CAIssue });
data.push({ name: 'CAIssueRequest', value: CAIssueRequest });
data.push({ name: 'CAReceive', value: CAReceive });
data.push({ name: 'CAReceiveRequest', value: CAReceiveRequest });
data.push({ name: 'CARequest', value: CARequest });
data.push({ name: 'CATransfer', value: CATransfer });
data.push({ name: 'CRMComsRule', value: CRMComsRule });
data.push({ name: 'CRMComsInit', value: CRMComsInit });
data.push({ name: 'Customer', value: Customer });
data.push({ name: 'CRMLead', value: CRMLead });
data.push({ name: 'CRMTicket', value: CRMTicket });
data.push({ name: 'EXPAllocate', value: EXPAllocate });
data.push({ name: 'EXPAllocateAP', value: EXPAllocateAP });
data.push({ name: 'EXPAllocateAPInput', value: EXPAllocateAPInput });
data.push({ name: 'EXPAllocateInput', value: EXPAllocateInput });
data.push({ name: 'EXPAllocatePM', value: EXPAllocatePM });
data.push({ name: 'EXPInvoicable', value: EXPInvoicable });
data.push({ name: 'EXPInvoice', value: EXPInvoice });
data.push({ name: 'EXPInvoiceItem', value: EXPInvoiceItem });
data.push({ name: 'EXPItem', value: EXPItem });
data.push({ name: 'EXPOrder', value: EXPOrder });
data.push({ name: 'EXPOrderItem', value: EXPOrderItem });
data.push({ name: 'EXPPayment', value: EXPPayment });
data.push({ name: 'EXPGeneralOrder', value: EXPGeneralOrder });
data.push({ name: 'EXPGeneralOrderItem', value: EXPGeneralOrderItem });
data.push({ name: 'EXPPurchaseOrder', value: EXPPurchaseOrder });
data.push({ name: 'EXPPurchaseOrderItem', value: EXPPurchaseOrderItem });
data.push({ name: 'EXPImportDutyOrder', value: EXPImportDutyOrder });
data.push({ name: 'EXPImportDutyOrderItem', value: EXPImportDutyOrderItem });
data.push({ name: 'EXPPayrollOrder', value: EXPPayrollOrder });
data.push({ name: 'EXPPayrollOrderItem', value: EXPPayrollOrderItem });
data.push({ name: 'EXPInsuranceOrder', value: EXPInsuranceOrder });
data.push({ name: 'EXPInsuranceOrderItem', value: EXPInsuranceOrderItem });
data.push({ name: 'EXPTaxOrder', value: EXPTaxOrder });
data.push({ name: 'EXPTaxOrderItem', value: EXPTaxOrderItem });
data.push({ name: 'EXPLogisticOrder', value: EXPLogisticOrder });
data.push({ name: 'EXPLogisticOrderItem', value: EXPLogisticOrderItem });
data.push({ name: 'EXPEquipmentProcurementOrder', value: EXPEquipmentProcurementOrder });
data.push({ name: 'EXPEquipmentProcurementOrderItem', value: EXPEquipmentProcurementOrderItem });
data.push({ name: 'EXPAssetProcurementOrder', value: EXPAssetProcurementOrder });
data.push({ name: 'EXPAssetProcurementOrderItem', value: EXPAssetProcurementOrderItem });
data.push({ name: 'EXPExtraPayableOrder', value: EXPExtraPayableOrder });
data.push({ name: 'EXPExtraPayableOrderItem', value: EXPExtraPayableOrderItem });
data.push({ name: 'EXPBudget', value: EXPBudget });
data.push({ name: 'WFApprovalPolicys', value: WFApprovalPolicys });
data.push({ name: 'WFApprovalPendings', value: WFApprovalPendings });
data.push({ name: 'OFTask', value: OFTask });
data.push({ name: 'OFDailyReport', value: OFDailyReport });
data.push({ name: 'OFMeeting', value: OFMeeting });
data.push({ name: 'OFDocument', value: OFDocument });
data.push({ name: 'OFBulletin', value: OFBulletin });
data.push({ name: 'OFObjective', value: OFObjective });

data.push({ name: 'EXRInvoicable', value: EXRInvoicable });
data.push({ name: 'EXRInvoice', value: EXRInvoice });
data.push({ name: 'EXRInvoiceItem', value: EXRInvoiceItem });
data.push({ name: 'EXROrder', value: EXROrder });
data.push({ name: 'EXROrderItem', value: EXROrderItem });
data.push({ name: 'EXROtherOrder', value: EXROtherOrder });
data.push({ name: 'EXROtherOrderItem', value: EXROtherOrderItem });

data.push({ name: 'FixedService', value: FixedService });
data.push({ name: 'ExpandableService', value: ExpandableService });
data.push({ name: 'Food', value: Food });
data.push({ name: 'Beverage', value: Beverage });
data.push({ name: 'Good', value: Good });
data.push({ name: 'HRAdjust', value: HRAdjust });
data.push({ name: 'HRAdjustItem', value: HRAdjustItem });
data.push({ name: 'HRAllowance', value: HRAllowance });
data.push({ name: 'HRAllowanceItem', value: HRAllowanceItem });
data.push({ name: 'HRCommision', value: HRCommision });
data.push({ name: 'HRCommisionItem', value: HRCommisionItem });
data.push({ name: 'HROrder', value: HROrder });
data.push({ name: 'HROrderItem', value: HROrderItem });
data.push({ name: 'HRWorkingSalary', value: HRWorkingSalary });
data.push({ name: 'HRWorkingSalaryItem', value: HRWorkingSalaryItem });
data.push({ name: 'HRWorkingAttendance', value: HRWorkingAttendance });
data.push({ name: 'HRWorkingTimesheet', value: HRWorkingTimesheet });
data.push({ name: 'HRWorkingDay', value: HRWorkingDay });
data.push({ name: 'HRLeave', value: HRLeave });
data.push({ name: 'HROvertimeRequest', value: HROvertimeRequest });
data.push({ name: 'HRAttendanceBatch', value: HRAttendanceBatch });
data.push({ name: 'ICAdjust', value: ICAdjust });
data.push({ name: 'ICAdjustItem', value: ICAdjustItem });
data.push({ name: 'ICCounting', value: ICCounting });
data.push({ name: 'ICCountingItem', value: ICCountingItem });
data.push({ name: 'ICInventorySerial', value: ICInventorySerial });
data.push({ name: 'ICInventoryStock', value: ICInventoryStock });
data.push({ name: 'ICIssue', value: ICIssue });
data.push({ name: 'ICIssueItem', value: ICIssueItem });
data.push({ name: 'ICReceipt', value: ICReceipt });
data.push({ name: 'ICReceiptItem', value: ICReceiptItem });
data.push({ name: 'ICTransfer', value: ICTransfer });
data.push({ name: 'ICTransferItem', value: ICTransferItem });
data.push({ name: 'ICBOM', value: ICBOM });
data.push({ name: 'ICAssemblyOrder', value: ICAssemblyOrder });
data.push({ name: 'ICDeassemblyOrder', value: ICDeassemblyOrder });
data.push({ name: 'ICAssemblyOrderItem', value: ICAssemblyOrderItem });
data.push({ name: 'ICLocation', value: ICLocation });
data.push({ name: 'ICLocationAudit', value: ICLocationAudit });
data.push({ name: 'ICLotAudit', value: ICLotAudit });
data.push({ name: 'ICSerialAudit', value: ICSerialAudit });

data.push({ name: 'LGOrderItem', value: LGOrderItem });
data.push({ name: 'LGTransport', value: LGTransport });
data.push({ name: 'PMFeature', value: PMFeature });
data.push({ name: 'PMProject', value: PMProject });
data.push({ name: 'PMMilestone', value: PMMilestone });
data.push({ name: 'PMProjectTemplate', value: PMProjectTemplate });
data.push({ name: 'PMResource', value: PMResource });
data.push({ name: 'PMTask', value: PMTask });
data.push({ name: 'Service', value: Service });
data.push({ name: 'SPCPurchaseByICRule', value: SPCPurchaseByICRule });
data.push({ name: 'SPCPurchaseByICRuleItem', value: SPCPurchaseByICRuleItem });
data.push({ name: 'SPCPurchaseByARRule', value: SPCPurchaseByARRule });
data.push({ name: 'SPCPurchaseByARRuleItem', value: SPCPurchaseByARRuleItem });
data.push({ name: 'SPCSourcingPolicy', value: SPCSourcingPolicy });
data.push({ name: 'SPCSourcingPolicyItem', value: SPCSourcingPolicyItem });
data.push({ name: 'SPCSafeStockStatus', value: SPCSafeStockStatus });
data.push({ name: 'SPCDemandPurchase', value: SPCDemandPurchase });
data.push({ name: 'SPCDemandTransfer', value: SPCDemandTransfer });
data.push({ name: 'SPCDemand', value: SPCDemand });
data.push({ name: 'SPCDemandPlanning', value: SPCDemandPlanning });
data.push({ name: 'Vendor', value: Vendor });

data.push({ name: 'FAAsset', value: FAAsset });
data.push({ name: 'FAAssetRegister', value: FAAssetRegister });
data.push({ name: 'FAAssetAdjInc', value: FAAssetAdjInc });
data.push({ name: 'FAAssetAdjDec', value: FAAssetAdjDec });
data.push({ name: 'FAAssetDispose', value: FAAssetDispose });
data.push({ name: 'FAAssetDepreciate', value: FAAssetDepreciate });

data.push({ name: 'FAEquipment', value: FAEquipment });
data.push({ name: 'FAEquipmentRegister', value: FAEquipmentRegister });
data.push({ name: 'FAEquipmentDispose', value: FAEquipmentDispose });
data.push({ name: 'FAEquipmentDepreciate', value: FAEquipmentDepreciate });

data.push({ name: 'MFProceduce', value: MFProceduce });
data.push({ name: 'MFRoute', value: MFRoute });
data.push({ name: 'MFBOM', value: MFBOM });
data.push({ name: 'MFMDSTicket', value: MFMDSTicket });
data.push({ name: 'MFMDSTicketItem', value: MFMDSTicketItem });
data.push({ name: 'MFMDSSummary', value: MFMDSSummary });
data.push({ name: 'MFMDSSummaryItem', value: MFMDSSummaryItem });
data.push({ name: 'MFMPS', value: MFMPS });
data.push({ name: 'MFMPSItem', value: MFMPSItem });
data.push({ name: 'MFMRPSummary', value: MFMRPSummary });
data.push({ name: 'MFMRPSummaryItem', value: MFMRPSummaryItem });
data.push({ name: 'MFMakeOrder', value: MFMakeOrder });
data.push({ name: 'MFMakeOrderItem', value: MFMakeOrderItem });
data.push({ name: 'MFWorkTicket', value: MFWorkTicket });
data.push({ name: 'MFWorkMove', value: MFWorkMove });
data.push({ name: 'MFMaterialIssue', value: MFMaterialIssue });
data.push({ name: 'MFMaterialIssueItem', value: MFMaterialIssueItem });
data.push({ name: 'ARServeMaterialIssue', value: ARServeMaterialIssue });
data.push({ name: 'ARServeMaterialIssueItem', value: ARServeMaterialIssueItem });
data.push({ name: 'ARServeMaterialCounting', value: ARServeMaterialCounting });
data.push({ name: 'ARServeMaterialCountingItem', value: ARServeMaterialCountingItem });
data.push({ name: 'ARServeMonthlyReport', value: ARServeMonthlyReport });
data.push({ name: 'ARServeBOM', value: ARServeBOM });

data.push({ name: 'PNLJournal', value: PNLJournal });
data.push({ name: 'PNLJournalLedgerStatus', value: PNLJournalLedgerStatus });
data.push({ name: 'PNLPosting', value: PNLPosting });
data.push({ name: 'PNLServeCosting', value: PNLServeCosting });
data.push({ name: 'PNLPostingRetry', value: PNLPostingRetry });
data.push({ name: 'PNLLedgerPosting', value: PNLLedgerPosting });
data.push({ name: 'PNLPostByTemplate', value: PNLPostByTemplate });
data.push({ name: 'PNLPostByVoucher', value: PNLPostByVoucher });
data.push({ name: 'PNLReEntry', value: PNLReEntry });
data.push({ name: 'PNLRejected', value: PNLRejected });
data.push({ name: 'PNLJournalGroupingTemplate', value: PNLJournalGroupingTemplate });
data.push({ name: 'PNLJournalGrouping', value: PNLJournalGrouping });

data.push({ name: 'GLCostCenter', value: GLCostCenter });
data.push({ name: 'ExchangeRate', value: ExchangeRate });
data.push({ name: 'GLJournal', value: GLJournal });
data.push({ name: 'GLJournalEntry', value: GLJournalEntry });
// Phiếu kế toán hợp nhất (đợt 5): nhiều pack dựng từ một bộ nhóm (chỉ khác nhóm mở sẵn, có/không Theo phiếu mẫu).
GLVoucherPacks.forEach((pack) => data.push(pack));
// Trạng thái ghi sổ trên danh sách chứng từ nguồn ở chế độ Kế toán (pack <Bảng>Ledger).
LedgerStatusPacks.forEach((pack) => data.push(pack));
data.push({ name: 'GLPostedJournal', value: GLPostedJournal });
data.push({ name: 'GLPostedJournalEntry', value: GLPostedJournalEntry });
data.push({ name: 'GLAdjustBalance', value: GLAdjustBalance });
data.push({ name: 'GLAdjustBalanceItem', value: GLAdjustBalanceItem });
data.push({ name: 'GLServeCosting', value: GLServeCosting });
data.push({ name: 'GLServeCostingItem', value: GLServeCostingItem });
data.push({ name: 'GLMFCosting', value: GLMFCosting });
data.push({ name: 'GLMFCostingItem', value: GLMFCostingItem });
data.push({ name: 'GLPNLCalculate', value: GLPNLCalculate });
data.push({ name: 'GLPNLCalculateItem', value: GLPNLCalculateItem });
data.push({ name: 'GLFXRevaluation', value: GLFXRevaluation });

data.push({ name: 'ARServicePlan', value: ARServicePlan });
data.push({ name: 'ARServicePlanItem', value: ARServicePlanItem });
data.push({ name: 'ARServiceOrder', value: ARServiceOrder });
data.push({ name: 'ARTradeIn', value: ARTradeIn });
data.push({ name: 'ARWarranty', value: ARWarranty });
data.push({ name: 'ARWarrantyClaim', value: ARWarrantyClaim });
data.push({ name: 'ARProductTrial', value: ARProductTrial });
data.push({ name: 'ARDeliveryInspection', value: ARDeliveryInspection });
data.push({ name: 'ARAssetRegistration', value: ARAssetRegistration });
data.push({ name: 'ARMaintainPlan', value: ARMaintainPlan });
data.push({ name: 'ARMaintainReminder', value: ARMaintainReminder });
data.push({ name: 'B2BPartnership', value: B2BPartnership });
data.push({ name: 'B2BCatalog', value: B2BCatalog });
data.push({ name: 'B2BOrder', value: B2BOrder });
data.push({ name: 'B2BItemMapping', value: B2BItemMapping });
data.push({ name: 'B2BSupplierPartner', value: B2BSupplierPartner });
data.push({ name: 'B2BSupplierOrder', value: B2BSupplierOrder });
data.push({ name: 'B2BBuyerPartner', value: B2BBuyerPartner });
data.push({ name: 'B2BBuyerOrder', value: B2BBuyerOrder });
data.push({ name: 'SysDataAudit', value: SysDataAudit });
data.push({ name: 'SysDataBackup', value: SysDataBackup });
data.push({ name: 'AIJobQueue', value: AIJobQueue });
data.push({ name: 'AIKnowledgeBase', value: AIKnowledgeBase });
data.push({ name: 'AIDocumentSource', value: AIDocumentSource });
data.push({ name: 'ItemSubstitute', value: ItemSubstitute });
data.push({ name: 'POSCashSettlement', value: POSCashSettlement });

data.push({ name: 'APQuotation', value: APQuotation });
data.push({ name: 'APVendorPromotion', value: APVendorPromotion });
data.push({ name: 'DeployCustomer', value: DeployCustomer });
data.push({ name: 'DeployItemGood', value: DeployItemGood });
data.push({ name: 'DeployItemFood', value: DeployItemFood });
data.push({ name: 'DeployItemBeverage', value: DeployItemBeverage });
data.push({ name: 'DeployItemMaterial', value: DeployItemMaterial });
data.push({ name: 'DeployItemConsumable', value: DeployItemConsumable });
data.push({ name: 'DeployItemFixedService', value: DeployItemFixedService });
data.push({ name: 'DeployItemExtraFee', value: DeployItemExtraFee });
data.push({ name: 'DeployItemServicePack', value: DeployItemServicePack });
data.push({ name: 'DeployItemDepositPack', value: DeployItemDepositPack });
// Phase 3b
data.push({ name: 'DeployStore', value: DeployStore });
data.push({ name: 'DeployEXPCostDeferral', value: DeployEXPCostDeferral });
data.push({ name: 'DeployAssetBalance', value: DeployAssetBalance });
data.push({ name: 'DeployInventoryBalance', value: DeployInventoryBalance });
data.push({ name: 'DeployCashBalance', value: DeployCashBalance });
data.push({ name: 'DeployEmployeeBalance', value: DeployEmployeeBalance });
data.push({ name: 'DeployVendorBalance', value: DeployVendorBalance });
data.push({ name: 'DeployTrialBalance', value: DeployTrialBalance });
data.push({ name: 'DeployCOA', value: DeployCOA });

// Sale Channel module — INT* (Phase 8B-P3 rename align with BE INTSale*)
data.push({ name: 'INTSaleApp', value: INTSaleApp });
data.push({ name: 'INTConnectionItem', value: INTConnectionItem });
data.push({ name: 'INTSaleOrder', value: INTSaleOrder });
data.push({ name: 'INTSaleEvent', value: INTSaleEvent });
data.push({ name: 'INTSaleJobQueue', value: INTSaleJobQueue });
data.push({ name: 'INTSaleFulfillment', value: INTSaleFulfillment });

// Social Channel module — INTSocial* (Phase 8E P1)
data.push({ name: 'INTSocialApp', value: INTSocialApp });
data.push({ name: 'INTSocialShop', value: INTSocialShop });
data.push({ name: 'INTSocialChat', value: INTSocialChat });
data.push({ name: 'INTSocialMessage', value: INTSocialMessage });
data.push({ name: 'INTSocialComment', value: INTSocialComment });
data.push({ name: 'INTSocialOrder', value: INTSocialOrder });
data.push({ name: 'INTSocialEvent', value: INTSocialEvent });
data.push({ name: 'INTSocialJobQueue', value: INTSocialJobQueue });

// Integration umbrella (Phase 9B-C) — INTConnection + 5 INT*App
data.push({ name: 'INTConnection', value: INTConnection });
data.push({ name: 'INTAdvertiseApp', value: INTAdvertiseApp });
data.push({ name: 'INTAffiliateApp', value: INTAffiliateApp });
data.push({ name: 'INTReviewApp', value: INTReviewApp });
data.push({ name: 'INTMessageEmailApp', value: INTMessageEmailApp });
data.push({ name: 'INTMessageSmsApp', value: INTMessageSmsApp });

export default data;
